import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "./styles.scss";
import { withTheme } from "@material-ui/core";
import { HeaderRenderer } from "../dataGrid/cellRenderer";
import { saveGridColumnState } from "./gridUtilities";
import { compose } from "recompose";
import { withUserProfile } from "../../userProfile/userProfileContext";

class DataGrid extends Component {
  constructor(props) {
    super(props);
    this.dataGrid = React.createRef();
    this.isColumnMoved = false;
    this.state = {filterPresent: false}
  }
  shouldComponentUpdate(nextProps,nextState) {
    if (this.props !== nextProps) {
      this.showGridOverlay(nextProps.showErrorMessage);
      return true;
    } else if(this.state != nextState) {
      return true
    }
    return false;
  }
  resizeGrid = ({ api }) => {
    this.gridApi = api;
    if (this.props.config?.skipSizeColumnsToFit === true) {
      return;
    }
    api.sizeColumnsToFit();
    if (this.gridApi.gridPanel) {
      this.gridApi.gridPanel.onFakeHorizontalScroll();
    }
  };

  onGridReady = (gridApi) => {
    gridApi.api.gridName = this.props.config.title;
    this.resizeGrid(gridApi);
    if (this.props.onGridReady) {
      this.props.onGridReady(gridApi);
      if (
        this.props.layoutContainer &&
        this.props.layoutContainer.layoutManager &&
        this.props.layoutContainer.layoutManager.eventHub
      ) {
        this.props.layoutContainer.layoutManager.eventHub.emit(
          `gridHeader_${this.props.layoutContainer._config.id}_setGridApi`,
          gridApi.api
        );
      }
      if(this.props.showErrorMessage){
        this.showGridOverlay(this.props.showErrorMessage);
      }
    }
  };

  onDragStopped = (event) => {
    if (this.gridApi && this.isColumnMoved) {
      const updatedConfig = saveGridColumnState({
        gridName: this.gridApi.gridName,
        columns: this.gridApi.columnController.getAllGridColumns(),
        userColumnPref: this.props.userData.userProfile?.columnPref,
        userId: this.props.userData.userProfile.userId,
      });
      this.props.userData.updateUserProfile({
        columnPref: updatedConfig,
      });
    }
    this.isColumnMoved = false;
  };

  onColumnMoved = () => {
    this.isColumnMoved = true;
  };

  customNavigation = (params) => {
    const previousCell = params.previousCellPosition;
    const suggestedNextCell = params.nextCellPosition;

    const KEY_UP = 38;
    const KEY_DOWN = 40;
    const KEY_LEFT = 37;
    const KEY_RIGHT = 39;

    switch (params.key) {
      case KEY_DOWN:
        // set selected cell on current cell + 1
        this.gridApi.forEachNode((node) => {
          if (previousCell.rowIndex + 1 === node.rowIndex) {
            node.setSelected(true, true);
          }
        });
        return suggestedNextCell;
      case KEY_UP:
        // set selected cell on current cell - 1
        this.gridApi.forEachNode((node) => {
          if (previousCell.rowIndex - 1 === node.rowIndex) {
            node.setSelected(true, true);
          }
        });
        return suggestedNextCell;
      case KEY_LEFT:
      case KEY_RIGHT:
        return suggestedNextCell;
      default:
        throw "this will never happen, navigation is always on of the 4 keys above";
    }
  };
  showGridOverlay = (message) => {
    if (!this.gridApi) {
      return;
    }
    switch (message) {
      case "error":
        this.gridApi.hideOverlay();
        this.gridApi.gridOptionsWrapper.setProperty(
          "overlayNoRowsTemplate",
          `<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;color:red">Something went wrong</span>`
        );
        this.gridApi.showNoRowsOverlay();
        break;
      case "loading":
        this.gridApi.hideOverlay();
        this.gridApi.showLoadingOverlay();
        break;
      case "success":
        if (this.gridApi.getDisplayedRowCount() === 0) {
          this.gridApi.gridOptionsWrapper.setProperty(
            "overlayNoRowsTemplate",
            `<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;color:black">No data available</span>`
          );
          this.gridApi.showNoRowsOverlay();
        } else {
          this.gridApi.hideOverlay();
        }
        break;
    }
  };
  onModelUpdated = () => {
    if (!this.gridApi) {
      return;
    }
    if (
      this.gridApi.getDisplayedRowCount() > 0 ||
      this.gridApi.getPinnedTopRowCount() > 0 ||
      this.gridApi.getPinnedBottomRowCount() > 0
    ) {
      this.gridApi.hideOverlay();
    } else {
      this.props.showErrorMessage
        ? this.showGridOverlay(this.props.showErrorMessage)
        : this.gridApi.showNoRowsOverlay();
    }
    //To check for different filters applied on shipment management-shipments grid
    if (this.props.onModelUpdated) {
      this.props.onModelUpdated(this.gridApi);
    }
  };

  onFilterChanged = (props) => {
    if (this.props.panelLabel) {
      this.setState({
          filterPresent: props.api.filterManager.advancedFilterPresent
      })
    }
    this.props.onFilterChanged?.(props)
  }

  render() {
    const filteredData = this.state.filterPresent ? this.gridApi.rowModel.rowsToDisplay.map((node) => node.data) : this.props.rowData
    return (
      <div className={`gridTheme-${this.props.theme.themeName}`}>
        <div
          className={`ag-theme-material theme-${this.props.theme.themeName}`}
        >
          <AgGridReact
            ref={this.dataGrid}
            rowSelection="single"
            rowDeselection="true"
            suppressMovableColumns="false"
            suppressDragLeaveHidesColumns={true}
            suppressCsvExport="false"
            stopEditingWhenGridLosesFocus
            animateRows={true}
            overlayLoadingTemplate={`<span class="ag-overlay-loading-center">Please wait while data is loading</span>`}
            overlayNoRowsTemplate={`<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;color:black">No data available</span>`}
            suppressRowClickSelection="false"
            suppressColumnVirtualisation={true}
            rowHeight={30}
            headerHeight={30}
            navigateToNextCell={this.customNavigation}
            frameworkComponents={{
              agColumnHeader: HeaderRenderer,
            }}
            {...this.props}
            onFilterChanged={this.onFilterChanged}
            scrollbarWidth={17}
            onGridReady={this.onGridReady}
            onGridSizeChanged={this.resizeGrid}
            onColumnMoved={this.onColumnMoved}
            onDragStopped={this.onDragStopped}
            suppressPropertyNamesCheck={true}
            onModelUpdated={this.onModelUpdated}
          />
        </div>
        {this.props.panelLabel?.(filteredData??[])}
      </div>
    );
  }
}
export default compose(withTheme(), withUserProfile)(DataGrid);
